import { unref, computed } from 'vue'

/**
 * ユーザーリスト表示項目(ステイタス)の利用
 * @param {MaybeRef.<string>} statusName ステイタス名
 */
export function useUserStatusAdditionalItemStatus({ statusName }) {
  /**
   * ステイタス表示テキスト
   * @type {ComputedRef.<string>}
   */
  const text = computed(() => {
    const name = unref(statusName)
    return name == null ? '-' : name
  })

  return { text }
}
